import { render } from "./DataPanel.vue?vue&type=template&id=4d761d2d&scoped=true&ts=true"
import script from "./DataPanel.vue?vue&type=script&lang=ts"
export * from "./DataPanel.vue?vue&type=script&lang=ts"

import "./DataPanel.vue?vue&type=style&index=0&id=4d761d2d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d761d2d"]])

export default __exports__